import { stampRequestStart } from '@payments-checkout/shared/observability';
import axios from 'axios';
import { env } from 'next-runtime-env';

export const instanceBin = axios.create();

instanceBin.interceptors.request.use(stampRequestStart);
instanceBin.interceptors.request.use((config) => {
  config.baseURL = env('NEXT_PUBLIC_BIN') ?? '';
  config.headers['X-Javascript-Enabled'] = true;
  config.headers['X-Language'] =
    typeof navigator !== 'undefined' ? navigator.language : 'pt-BR';
  config.headers['X-Color-Depth'] =
    typeof window !== 'undefined' ? window.screen.colorDepth : null;
  config.headers['X-Screen-Width'] =
    typeof window !== 'undefined' ? window.innerWidth : null;
  config.headers['X-Screen-Height'] =
    typeof window !== 'undefined' ? window.innerHeight : null;
  config.headers['X-TimeZone'] = new Date().getTimezoneOffset();
  config.headers['Content-Type'] = 'application/json';
  return config;
});
